import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import * as st from './bottomBar.module.scss'
import { Icon, IconType, Spacer, spacerSpacing, Text } from 'DVWebNodeUI'
import { ShareModal } from './shareModal'
import { FeedbackForm } from '../feedbackForm/feedbackForm'

export interface IBottomBarProps {
  isMobile: boolean
  isPurchaseRestricted: boolean
  useTermsAndFeedback: boolean
  isRetail: boolean
  bottomBar: WpsRuntime.atv.wps.BottomBarModelProps
}

const TermsAndConditions = ({ termsText }: {termsText: WpsRuntime.atv.wps.DVString}) => (
  <div className={`avu-full-width ${st.termsAndConditions}`}>
    <Text string={termsText}/>
  </div>
)

export const BottomIconWithLink: React.StatelessComponent<{iconType : IconType}> = props => (
  <div className={st.linkWithIcon}>
    <div className={st.bottomIcon}>
      <Icon className={st.icon} use={props.iconType}/>
    </div>
    {props.children}
  </div>
)

export const BottomBarComp = ({ isMobile, isPurchaseRestricted, useTermsAndFeedback,
                                isRetail, bottomBar }: IBottomBarProps) => {

  const shareModalProps = { isMobile, ...bottomBar }

  return (
    useTermsAndFeedback && !isPurchaseRestricted ? (
      <div className={`dv-dp-node-bottom ${st.bottomBar}`}>
        <TermsAndConditions termsText={bottomBar.termsText}/>
        <Spacer className={st.iconsAndFeedback} space={spacerSpacing.m}>
          <BottomIconWithLink iconType={IconType.SHARE}><ShareModal {...shareModalProps}/></BottomIconWithLink>
          {isRetail && <BottomIconWithLink iconType={IconType.EDIT}>{<FeedbackForm />}</BottomIconWithLink>}
          <BottomIconWithLink iconType={IconType.HELP}><Text string={bottomBar.helpText}/></BottomIconWithLink>
        </Spacer>
      </div>
    ) : null
  )
}

export const BottomBar = BottomBarComp
